<template>
  <v-container fluid>
    <v-row dense id="po">
      <v-col cols="3">
        <v-autocomplete
          filled
          readonly
          dense
          outlined
          placeholder=" "
          v-model="record.CardCode"
          :items="customers"
          label="Customer"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-text-field v-model="DocNum" outlined dense filled readonly label="Order No"></v-text-field>
      </v-col>

      <v-col cols="3">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          dense
          outlined
          v-model="storeId"
          :items="stores"
          label="Store"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="6" v-if="docCreate == true && copyStatus == false">
        <v-autocomplete
          dense
          outlined
          v-model="selectedProduct"
          :items="products"
          label="Search Product To Add To List"
          item-text="product.Name"
          item-value="id"
          @change="setOrderItem"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" id="docForm">
        <v-alert
          v-if="orderItems.length == 0 && docCreate == true"
          type="warning"
        >You have not added any Item.</v-alert>

        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="headers"
          :items="orderItems"
          item-key="o_i_t_m_s_id"
          hide-default-footer
          @item-selected="selectedRow"
          v-model="selectedItems"
          show-select
        >
          <template v-slot:item.Name="{ item }">
            <v-text-field
              class="orderInput"
              single-line
              outlined
              dense
              readonly
              filled
              v-model="item.Name"
              style="width: 300px"
            ></v-text-field>
          </template>

          <template v-slot:item.ref1="{ item }">
            <v-text-field
              class="orderInput"
              single-line
              outlined
              filled
              readonly
              dense
              v-model="item.ref1"
              style="width: 170px"
            ></v-text-field>
          </template>

          <template v-slot:item.Quantity="{ item }">
            <v-text-field
              class="orderInput"
              @input="inputChanged(item)"
              single-line
              outlined
              filled
              readonly
              dense
              v-model="item.Quantity"
              style="width: 135px"
            ></v-text-field>
          </template>

          <template v-slot:item.Price="{ item }">
            <v-text-field
              class="orderInput"
              @input="inputChanged(item)"
              single-line
              outlined
              dense
              v-model="item.Price"
              filled
              readonly
            ></v-text-field>
          </template>

          <template v-slot:item.DiscSum="{ item }">
            <v-text-field
              class="orderInput"
              @input="inputChanged(item)"
              single-line
              outlined
              dense
              v-model="item.DiscSum"
              filled
              readonly
            ></v-text-field>
          </template>

          <template v-slot:item.DisplayTotal="{ item }">
            <v-text-field
              class="orderInput"
              single-line
              outlined
              dense
              filled
              readonly
              v-model="item.DisplayTotal"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>

      <!-- <v-col cols="9"></v-col> -->

      <v-col cols="6">
        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model="totalBefDisc"
              label="Total Bef Disc."
              filled
              dense
              outlined
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="DiscOnTotal"
              label="Disc on Total"
              filled
              dense
              outlined
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="totalDisplayAmount"
              label="Total Bill"
              filled
              dense
              outlined
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="totalPaidAmount"
              label="Amount Paid"
              dense
              outlined
              filled
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="displayBalance"
              label="Balance"
              filled
              dense
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-btn color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  name: "NewPurchaseOrder",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    selectedProduct: null,
    SumApplied: 0,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    orderItems: [],
    customers: [],
    products: [],
    stores: [],
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Product", value: "Name" },
      { text: "Ref No./ IMEI", value: "ref1" },
      { text: "Qty", value: "Quantity" },
      { text: "Price", value: "Price" },
      { text: "Discount", value: "DiscSum" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" },
    ],
  }),
  computed: {
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    DiscOnTotal() {
      let disc = 0;
      if (this.record.DiscSum) {
        disc = this.record.DiscSum.toLocaleString();
      }
      return disc;
    },
    totalBefDisc() {
      let total = 0;
      if (this.record.DocTotalBfDisc) {
        total = this.record.DocTotalBfDisc.toLocaleString();
      }
      return total;
    },
    displayBalance() {
      let balance = 0;
      if (this.record.Balance) {
        balance = this.record.Balance.toLocaleString();
      }
      return balance;
    },
    totalPaidAmount() {
      let total = 0;
      if (this.record.PaidSum) {
        total = this.record.PaidSum.toLocaleString();
      }
      return total;
    },
    totalDisplayAmount() {
      let total = 0;
      if (this.record.DocTotal) {
        total = this.record.DocTotal.toLocaleString();
      }
      return total;
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.Name = row.product.Name;
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    deleteRow() {
      if (this.activeRow == null) {
        this.$refs.snackbar.show("Please select the item to delete", "red");
      } else {
        const id = this.activeRow;
        const selectedRow = this.orderItems.find((record) => {
          return record.o_i_t_m_s_id === id;
        });
        const pos = this.orderItems.indexOf(selectedRow);
        if (pos === -1) {
          return;
        }
        this.orderItems.splice(pos, 1);
        this.activeRow = null;
        this.selectedItems = [];
      }
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    inputChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find((record) => {
        return record.o_i_t_m_s_id === data.o_i_t_m_s_id;
      });

      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      // update record
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
    },
    setOrderItem() {
      if (this.storeId == null) {
        this.$refs.snackbar.show(
          "Please select store or set ita as default on general settings!",
          "red"
        );
      } else {
        const itm2Id = this.selectedProduct;
        const itm2 = this.products.find((record) => {
          return record.id == itm2Id;
        });
        const LineNum = this.orderItems.length + 1;
        const store_id = this.storeId;
        // check if the product exist
        const orderProduct = this.orderItems.find((record) => {
          return record.o_i_t_m_s_id === itm2.product.id;
        });
        if (orderProduct) {
          this.$refs.snackbar.show(
            "That product already exist on the List",
            "red"
          );
        } else {
          const orderItem = {
            LineNum: LineNum,
            o_i_t_m_s_id: itm2.product.id,
            store_id: store_id,
            Name: itm2.product.Name,
            Quantity: null,
            Price: null,
            LineTotal: 0,
            DisplayTotal: 0,
          };
          this.orderItems.push(orderItem);
        }
        // end of check
        this.selectedProduct = "";
      }
    },
    sendData() {
      if (this.selectedItems.length > 0) {
          const data = {id: this.record.id,
          rows: this.selectedItems
          };
          //this.loader = true;
          this.$emit("data", data);
      } else {
        this.$refs.snackbar.show("You must have at least one product", "red");
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    productsInit(id) {
      const self = this;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      //  get store id first
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.productsInit(res.ResponseData.store_id);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.DefaultStockStore) {
              self.storeId = res.ResponseData.DefaultStockStore;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
    // this.getProducts();
    this.getStores();
    this.getGenSettings();
    this.getDocNum();
  },
};
</script>

<style  scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>